import BlockClickable from './BlockClickable.vue';
import utile from '../../utile';

export default {
  getComponentByConfig(config) {
    return utile.resetComponentByConfig(
      config,
      'blockClickable',
      BlockClickable
    );
  },
};
